import {atomWithStorage} from 'jotai/utils';

export const starredBrandsInfoAtom = atomWithStorage<{
  selected: string[];
  active: boolean;
}>('starred-brands', {selected: [], active: true});
